import axios from "axios";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

/*BootstrapTable anbd table Related*/
import InputSelect from "../../../components/common/InputSelect";

/*Loader */

/*animation*/
/*Inputs*/
/*Styles*/
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import SubGroup from "../../common/SubGroup";
import Loader from "../../common/loader/Loader";
import "./LineTypeSettings.css";

function useVisibility() {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        root: null, // Use the viewport as the container to check visibility
        rootMargin: "0px",
        threshold: 0.1, // Adjust this as needed
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return [ref, isVisible];
}

export default function LineTypeLinked(props) {
  const [ref, isVisible] = useVisibility();
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [isLoading, setIsLoading] = useState(true);

  /**
   * SPORTS DATA
   */
  const [sport, setSport] = useState("CBB  ");
  //const onSportChanged = useCallback((s) => setSport(s), []);
  const [sports, setSports] = useState([]);
  const getSports = useCallback(() => {
    if (!isVisible) return;

    const url = `${process.env.REACT_APP_API2_URL}/Player/GetSports`;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setSport(data[0].idSport);

        const mappedData = data.map((item) => ({
          value: item.idSport,
          text: item.sportName,
        }));

        setSports(mappedData);
      });
  }, [isVisible]);

  /**
   * LINE TYPE LINK SYNCH DATA
   */
  const [lineTypesLinksInfo, setLineTypesLinksInfo] = useState({
    spreadSync: true,
    spreadOddsSync: true,
    totalSync: true,
    totalOddsSync: true,
    moneyLineSync: true,
    linkType: 0,
  });
  const handleChange = (event, key, value) => {
    setLineTypesLinksInfo((prev) => ({
      ...prev,
      [key]: event ? event.target.checked : value,
    }));
  };

  const getLineTypesLinksInfo = useCallback((force = false, sportArg) => {
    if (!force && !isVisible) return Promise.resolve();

    const s = sportArg ?? sport; // usa el sport pasado o el del estado
    const url = `${process.env.REACT_APP_API2_URL}/LineType/LineTypeLinks_GetSynch?IdLineTypeOut=${props.idLineTypeOut}&IdLineTypeIn=${props.idLineTypeIn}&IdSport=${s}`;

    return axios
      .get(url)
      .then(r => r.data)
      .then(data => {
        setLineTypesLinksInfo(data);
        setIsLoading(false);
        return data;
      });
  }, [isVisible, sport, props.idLineTypeOut, props.idLineTypeIn]);

  const onSportChanged = useCallback((s) => {
    setSport(s);
    setIsLoading(true);
    getLineTypesLinksInfo(true, s).finally(() => setIsLoading(false));
  }, [getLineTypesLinksInfo]);


  useEffect(() => {
    if (isVisible) {
      Promise.all([getSports(), getLineTypesLinksInfo()]).then(() =>
        setIsLoading(false)
      );
    }
  }, [isVisible]);

  const updateLineTypesLinksInfo = async () => {
    setIsLoading(true);
    const data = {
      IdLineTypeOut: props.idLineTypeOut,
      IdLineTypeIn: props.idLineTypeIn,
      IdSport: sport,
      SpreadSync: lineTypesLinksInfo.spreadSync,
      SpreadOddsSync: lineTypesLinksInfo.spreadOddsSync,
      TotalSync: lineTypesLinksInfo.totalSync,
      TotalOddsSync: lineTypesLinksInfo.totalOddsSync,
      MoneyLineSync: lineTypesLinksInfo.moneyLineSync,
      LinkType: lineTypesLinksInfo.linkType,
      IdUser: userInfo.userId,
    };
    const url = `${process.env.REACT_APP_API2_URL}/LineType/LineTypeLinks_Update`;
    try {
      await axios.post(url, data);
      await getLineTypesLinksInfo(true, sport); // ← recarga desde el backend
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div ref={ref} class="flex flex-col gap-4 p-4">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <InputSelect
            variant="outlined"
            size="small"
            label="Sport"
            name="name"
            data={sports}
            placeholder="DataFormatter"
            setSelectValue={onSportChanged}
            startValue={sport}
          />

          <b>Link Syncronization</b>

          <SubGroup title="Synchronization" className="p-4">
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineTypesLinksInfo.spreadSync}
                  onChange={(event) => {
                    handleChange(undefined, "spreadSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Spread"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineTypesLinksInfo.spreadOddsSync}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "spreadOddsSync",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Spread Odds"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineTypesLinksInfo.totalSync}
                  onChange={(event) => {
                    handleChange(undefined, "totalSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Total"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineTypesLinksInfo.totalOddsSync}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "totalOddsSync",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Total Odds"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineTypesLinksInfo.moneyLineSync}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "moneyLineSync",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Money Line"
            />
          </SubGroup>
          <FormControl component="fieldset">
            <RadioGroup
              label
              value={lineTypesLinksInfo.linkType}
              onChange={(event) => {
                handleChange(event, "linkType");
              }}
              row
            >
              <FormControlLabel
                control={<Radio value={0} size="small" color="primary" />}
                label="Copy the favorite line from parent"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={1} size="small" color="primary" />}
                label="Calc the favorite line from parent"
                labelPlacement="end"
              />
            </RadioGroup>
          </FormControl>
          <Button
            type="button"
            onClick={updateLineTypesLinksInfo}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </>
      )}

      {/* <Changes
        title={`Last Changes in ${sport} linetype links synch`}
        params={{
          ChangeType: 21,
          IdSport: sport,
          Param1: props.idLineTypeOut,
          Param2: props.idLineTypeIn,
          Param3: 0,
        }}
      /> */}
    </div>
  );
}
